/* eslint-disable @typescript-eslint/no-explicit-any */

import { ITEMS_PER_PAGE } from "../other/constants";
import { DISTANCE_MAP, SORT_MAP } from "./constants";

const regexMagicUnitId = (unitId: string) => unitId.replace(/\b(([a-z]{1,4})\s*([a-z0-9]+\d))\b/gim, `$2-$3`);

export const parseData = (data: any, Entry: any, viewUnit: string, purchaseInquiry: string) => {
  return data.map((item: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { blocks, branch, productFeatures, productImages, ...rest } = item.fields || {};
    const unitId = item.sys?.id;

    const img = productImages?.[0]?.thumbnails?.transformBaseUrl;

    const branchId = branch?.sys?.id;
    let branchName = "",
      branchSlug = "";

    if (branchId) {
      for (const target of Entry) {
        const subId = target.sys?.id;

        if (subId === branchId) {
          branchName = target.fields?.name;

          const stateSlug = target.fields?.state.replace(" ", "-").toLowerCase();
          branchSlug = `/${stateSlug}/${target.fields?.slug}`;
          break;
        }
      }
    }

    return {
      viewUnit,
      purchaseInquiry,
      branchName,
      branchSlug,
      image: img ? img : "/placeholders/sales-no-preview.png",
      alt: productImages?.[0]?.description || "image",
      placeholder:
        "data:image/png;base64,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",
      ...rest,
      id: unitId,
    };
  });
};

// interface IBranch {
//   [key: string]: {
//     distance: string;
//     coordinates: string;
//     ids: string[] | [];
//   };
// }

export const getUrl = async (
  filters: any,
  sort: string,
  // branches: IBranch | null,
  // setBranches: (obj: any) => void,
  currentPage: number
) => {
  let addition = "";
  let url = "";

  const skip = filters.unitId ? 0 : (currentPage - 1) * ITEMS_PER_PAGE;

  const mainUrl = `&content_type=usedProduct&limit=${ITEMS_PER_PAGE}&skip=${skip}&order=${SORT_MAP[sort] || ""}`;

  if (filters.allUnits) {
    url = mainUrl;
  } else if (filters.unitId) {
    addition = `&query=${regexMagicUnitId(filters.unitId)}`;
    // addition = `&query=${filters.unitId}`;

    url = mainUrl + addition;
  } else {
    if (filters.unitType) {
      const unit = filters.unitType;
      addition += `&fields.productType=${unit}`;
    }

    if (filters.priceRange) {
      if (filters.priceRange === "0_10000") {
        addition += "&fields.price[lte]=10000";
      } else if (filters.priceRange === "75,000+") {
        addition += "&fields.price[gte]=75000";
      } else {
        const price = filters.priceRange.split("_");
        addition += `&fields.price[gte]=${parseInt(price[0])}&fields.price[lte]=${parseInt(price[1])}`;
      }
    }

    if (filters.distance && filters.coordinates) {
      // ! new options for filtering

      if (filters.distance === "200_miles") {
        addition += `&fields.coordinates[near]=${filters.coordinates},100000`;
      } else {
        addition += `&fields.coordinates[near]=${filters.coordinates},${DISTANCE_MAP[filters.distance]}`;
      }
      return (url = mainUrl + addition);
    } else {
      //   if there is no coordinates and distance, just return url
      return (url = mainUrl + addition);
    }
  }

  return url;
};

export const parseNewApiData = (data: any, viewUnit: string, purchaseInquiry: string) => {
  return (data.data.items || []).map((item: any, idx: number) => ({
    ...item,
    id: `${idx}-${item.slug}`,
    image: item.images ? item.images : "/placeholders/sales-no-preview.png",
    viewUnit,
    purchaseInquiry,
    branchName: item.branch,
  }));
};

export const getUnitSearchUrl = (filters: { unitId: string; locale: string; currentPage: number; order: string }) =>
  `&page=${filters.currentPage}&locale=${filters.locale}&order=${filters.order}&query=${filters.unitId}`;
